import { render, staticRenderFns } from "./StatsDailyExam.vue?vue&type=template&id=4135a790&"
import script from "./StatsDailyExam.vue?vue&type=script&lang=js&"
export * from "./StatsDailyExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports